import React from 'react';

import { addYears } from 'date-fns';

import { DatePicker } from 'components/shared/DatePicker';

import s from './index.module.css';

type Props = {
  onChange: (value?: Date) => void;
  value?: Date;
};

export function FlightsDatePicker({ onChange, value }: Props) {
  return (
    <DatePicker
      className={s.datePickerContainer}
      classNames={{ day: s.cssDay, weekday: s.cssWeekday }}
      mode="single"
      onSelect={onChange}
      selected={value}
      endMonth={addYears(new Date(), 10)}
      defaultMonth={value}
    />
  );
}
